"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "laureana-cilento": {
    "4299d678": [{
      "hkey": "52cb204c",
      "slug": "matonti-vetrali",
      "name": "Matonti-Vetrali",
      "primary": true,
      "skipSearch": false
    }],
    "matonti": [{
      "hkey": "52cb204c",
      "slug": "matonti-vetrali",
      "name": "Matonti-Vetrali",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;